export const product = {
  ProductPartitionPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdGroupCriterionId',
      'ProductGroup',
      'PartitionType',
      'CurrentMaxCpc',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AbsoluteTopImpressionRatePercent',
      'Spend',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
      'AssetGroupName',
    ],
    mandatory: [
      'ProductGroup',
      'PartitionType',
    ],
  },
  ProductPartitionUnitPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdGroupCriterionId',
      'ProductGroup',
      'CurrentMaxCpc',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'AbsoluteTopImpressionRatePercent',
      'AssetGroupName',
    ],
    mandatory: [
      'AdGroupCriterionId',
      'ProductGroup',
    ],
  },
  ProductDimensionPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'MerchantProductId',
      'Title',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
      'AbsoluteTopImpressionRatePercent',
      'AssetGroupName',
    ],
    mandatory: [
    ],
  },
  ProductSearchQueryPerformanceReport: {
    mandatory: [
      'AccountName',
      'CampaignName',
      'SearchQuery',
    ],
    default: [
      'AccountName',
      'CampaignName',
      'SearchQuery',
      'MerchantProductId',
      'Title',
      'AdGroupCriterionId',
      'ProductGroup',
      'PartitionType',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AbsoluteTopImpressionRatePercent',
      'Spend',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
      'AssetGroupName',
    ],
  },
  ProductMatchCountReport: {
    mandatory: [
      'AccountName',
      'CampaignName',
      'ProductGroup',
      'MatchedProductsAtProductGroup',
      'AssetGroupName',
    ],
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupCriterionId',
      'ProductGroup',
      'PartitionType',
      'MatchedProductsAtCampaign',
      'MatchedProductsAtAdGroup',
      'MatchedProductsAtProductGroup',
    ],
  },
  ProductNegativeKeywordConflictReport: {
    mandatory: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'NegativeKeyword',
      'AssetGroupName',
    ],
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdGroupCriterionId',
      'MerchantProductId',
      'NegativeKeyword',
      'ConflictLevel',
    ],
  },
};

